import { useMemo } from "react";

/**
 * Given a gorsel URL from backend, return a browser-usable URL.
 * - If it starts with /api/files/, append ?auth=<token> and prepend REACT_APP_BACKEND_URL.
 * - Otherwise return as-is.
 */
export function imgSrc(url) {
  if (!url) return "";
  if (url.startsWith("/api/files/") || url.startsWith("/api/")) {
    const token = localStorage.getItem("og_token");
    const base = process.env.REACT_APP_BACKEND_URL || "";
    const sep = url.includes("?") ? "&" : "?";
    return `${base}${url}${sep}auth=${encodeURIComponent(token || "")}`;
  }
  return url;
}

/** Build a src for a storage_path (e.g. "otogaleri/vehicles/xx/yy.jpg") */
export function storageSrc(path) {
  return imgSrc(`/api/files/${path}`);
}

export function useVehicleImages(v) {
  return useMemo(() => {
    const all = [];
    if (v?.gorsel) all.push({ src: imgSrc(v.gorsel), removable: false });
    for (const p of v?.gorseller || []) {
      all.push({ src: storageSrc(p), path: p, removable: true });
    }
    return all;
  }, [v]);
}
